<app-selected-project [isESAUDL]="true"></app-selected-project>
<div *ngIf="!isProjectOwnershipValid && selectedProject" class="isProjectOwnershipValid">
  <p>You can not modify or run someone's project</p>
</div>
<div *ngIf="isProjectRunning && selectedProject && isProjectOwnershipValid" class="isProjectRunningLabel">
  <p>Changes cannot be made while model is running</p>
</div>
<div *ngIf="selectedProject" class="pt-3 pr-5 pb-5 pl-5">
  <app-wizard class="surface-200" [items]="tabService.items" [message]="message" [loading]="loading" [isESAUDL]="true"
      [activeItem]="activeItem" [selectedProject]="selectedProject" [selectedProjectStatus]="selectedProjectStatus" [isSetupValid]="isSetupValid"
      (activeIndexChangeEmitter)="onActiveIndexChange($event)"></app-wizard>
  <div class="shadow-8 surface-0 p-3">
      <ng-container *ngIf="activeItem?.index == 0">
          <app-esa-setup [disciplinePk]="disciplinePk" (isSetupValidEvent)="validateSetup($event)"></app-esa-setup>
      </ng-container>

      <ng-container *ngIf="activeItem?.index == 1">
        <app-esa-run-project></app-esa-run-project>
      </ng-container>

      <ng-container *ngIf="activeItem?.index == 2">
          <app-esa-output-project [selectedProject]="selectedProject"></app-esa-output-project>
      </ng-container>
  </div>
</div>
<!-- This is to force the font family to load upon being in the udl overlap assessment, thus no loading time for when we render the tab icon numbers -->
<span class="material-symbols-rounded" style="opacity: 1%;">counter_1</span>